import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import {AuthComponent} from './theme/layout/auth/auth.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'telisubscribe',
        loadChildren: () => import('./teli/subscribe/subscribe.module').then(module => module.SubscribeModule)
      },
      {
        path: 'teliprovision',
        loadChildren: () => import('./teli/teli.module').then(module => module.TeliModule)
      },
      {
        path: 'teliadminservices',
        loadChildren: () => import('./teli/admindevices/admindevices.module').then(module => module.AdminDevicesModule)
      },
      {
        path: 'telisearch',
        loadChildren: () => import('./teli/vendorsearch/vendorsearch.module').then(module => module.VendorSearchModule)
      },
      {
        path: 'telireports',
        loadChildren: () => import('./teli/reports/reports.module').then(module => module.ReportsModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'layout',
        loadChildren: () => import('./demo/pages/layout/layout.module').then(module => module.LayoutModule)
      },
      {
        path: 'widget',
        loadChildren: () => import('./demo/widget/widget.module').then(module => module.WidgetModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./demo/users/users.module').then(module => module.UsersModule)
      },
      {
        path: 'basic',
        loadChildren: () => import('./demo/ui-elements/ui-basic/ui-basic.module').then(module => module.UiBasicModule)
      },
      {
        path: 'advance',
        loadChildren: () => import('./demo/ui-elements/ui-adv/ui-adv.module').then(module => module.UiAdvModule)
      },
      {
        path: 'forms',
        loadChildren: () => import('./demo/pages/form-elements/form-elements.module').then(module => module.FormElementsModule)
      },
      {
        path: 'tbl-bootstrap',
        loadChildren: () => import('./demo/pages/tables/tbl-bootstrap/tbl-bootstrap.module').then(module => module.TblBootstrapModule)
      },
      {
        path: 'tbl-datatable',
        loadChildren: () => import('./demo/pages/tables/tbl-datatable/tbl-datatable.module').then(module => module.TblDatatableModule)
      },
      {
        path: 'register',
        loadChildren: () => import('./teli/auth/register/tregister.module').then(module => module.TRegisterModule)
      },
      {
        path: 'resetpass',
        loadChildren: () => import('./teli/auth/auth-reset-password/tauth-reset-password.module').then(module => module.TAuthResetPasswordModule)
      },
      {
        path: 'setnewpass',
        loadChildren: () => import('./teli/auth/auth-setnew-password/tauth-setnew-password.module').then(module => module.TAuthSetnewPasswordModule)
      },
      {
        path: '',
        //redirectTo: '/dashboard/analytics',
        redirectTo: '/teli/auth/signin',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'teli',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./teli/auth/auth.module').then(module => module.AuthModule)
      },
      {
        path: 'register',
        loadChildren: () => import('./teli/auth/register/tregister.module').then(module => module.TRegisterModule)
      },
      {
        path: 'resetpass',
        loadChildren: () => import('./teli/auth/auth-reset-password/tauth-reset-password.module').then(module => module.TAuthResetPasswordModule)
      },
      {
        path: 'setnewpass',
        loadChildren: () => import('./teli/auth/auth-setnew-password/tauth-setnew-password.module').then(module => module.TAuthSetnewPasswordModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, relativeLinkResolution: 'legacy'})],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
